import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { SignupComponent } from './signup/signup.component';
import { SplashComponent } from './splash/splash.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { TopnavComponent } from './topnav/topnav.component';
import { AppRoutingModule } from './app-routing.module';
import { SigninComponent } from './signin/signin.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule} from "@angular/forms";
import { DasboardComponent } from './dasboard/dasboard.component';
import { ProfileComponent } from './profile/profile.component';
import { MainComponent } from './main/main.component';
import { CreatePolicyComponent } from './create-policy/create-policy.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from "@angular/material/datepicker";
import {MatNativeDateModule} from '@angular/material/core';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTableModule} from '@angular/material/table';


import { TravelModalComponent } from './travel-modal/travel-modal.component';
import { LoaderComponent } from './loader/loader.component';
import { ToastrModule } from 'ngx-toastr';
import { PolicyDetailsComponent } from './policy-details/policy-details.component';
import { AllPoliciesComponent } from './all-policies/all-policies.component';
import { IncompleteTransactionsComponent } from './incomplete-transactions/incomplete-transactions.component';
import { ContactComponent } from './contact/contact.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ForgetPasswordDetailsComponent } from './forget-password-details/forget-password-details.component';
import { ViewCertComponent } from './view-cert/view-cert.component';
import { WalletComponent } from './wallet/wallet.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MoreInfoComponent } from './more-info/more-info.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { VerifyPaymentComponent } from './verify-payment/verify-payment.component';
import { VerifyPaymentWalletComponent } from './verify-payment/verify-payment-wallet.component';
import { GetQouteComponent } from './get-qoute/get-qoute.component';
import { RequestCertificateEditComponent } from './request-certificate-edit/request-certificate-edit.component';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ClaimsComponent } from './claims/claims.component';
import { ClaimsFormComponent } from './claims-form/claims-form.component';
import { ClaimDetailComponent } from './claim-detail/claim-detail.component';
import { ChartsComponent } from "./charts/charts.component";
import { ChartsTwoComponent } from './charts-two/charts-two.component';
@NgModule({ declarations: [
        AppComponent,
        SignupComponent,
        SplashComponent,
        SidenavComponent,
        TopnavComponent,
        SigninComponent,
        DasboardComponent,
        ProfileComponent,
        MainComponent,
        CreatePolicyComponent,
        TravelModalComponent,
        LoaderComponent,
        PolicyDetailsComponent,
        AllPoliciesComponent,
        IncompleteTransactionsComponent,
        ContactComponent,
        ForgetPasswordComponent,
        ForgetPasswordDetailsComponent,
        ViewCertComponent,
        WalletComponent,
        MoreInfoComponent,
        WelcomeComponent,
        VerifyPaymentComponent,
        VerifyPaymentWalletComponent,
        GetQouteComponent,
        RequestCertificateEditComponent,
        UploadModalComponent,
        ClaimsComponent,
        ClaimsFormComponent,
        ClaimDetailComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatDialogModule,
        MatTableModule,
        MatTooltipModule,
        FormsModule,
        CurrencyMaskModule,
        MatCheckboxModule,
        NgxFileDropModule,
        CanvasJSAngularChartsModule,
        ChartsTwoComponent,
        ChartsComponent], providers: [
        TravelModalComponent,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
